export default {
  namespace: 'page',
  state: {
    isTop: true
  },
  reducers: {
    setTop(state, payload) {
      const _state = JSON.parse(JSON.stringify(state)) // 必须得返回一个新的state 否则视图将不进行更新
      _state.isTop = payload.data.isTop
      return _state
    },
  },
  effects: {
    *setSroll({ data }, { put }) {
      yield put({
        type: "setTop", // 调用上面的方法
        data
      })
    }
  }
}
